let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("Wtwkp")).then(() => parcelRequire('gWtu0'));